import React from 'react';
import { Container } from './styles';
import Search from '~/components/Search';

const RelatorioDeVendas: React.FC = () => {
  function defaultOnlyReport() {
    return false;
  }
  return (
    <Container>
      <Search
        codTela={170}
        onlyReport
        newData={defaultOnlyReport}
        onRowClick={defaultOnlyReport}
      />
    </Container>
  );
};

export default RelatorioDeVendas;
